import React from 'react'

interface GapProps {
  width?: number
  height?: number
  className?: string
}

const Gap: React.FC<GapProps> = ({ width, height, className = '' }) => {
  const style: React.CSSProperties = {}

  if (width !== undefined) {
    style.minWidth = `${width}px`
    style.width = `${width}px`
    style.maxWidth = `${width}px`
  }

  if (height !== undefined) {
    style.minHeight = `${height}px`
    style.height = `${height}px`
    style.maxHeight = `${height}px`
  }

  return <div className={`shrink-0 ${className}`} style={style} />
}

export default Gap
